import { forwardRef, useEffect, useState } from "react";
import { Button, FormHelperText, Grid, TextField } from "@mui/material";
import { Typography } from "@mui/material";
import RadioAnswer from "../../../components/shared/radioAnswer/RadioAnswer";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const RadioQuestion = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      handlePayload,
      value,
      isEdit,
      latestStepQuestion,
      handleOfficeSoftware,
      handelRequiredQuestion,
      handleCurrentQuestion,
    },
    ref
  ) => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)");
    const [textfieldOn, setTextfieldOn] = useState(false);
    const [comboBoxOn, setComboBoxOn] = useState(false);
    const [other, setOther] = useState("");
    const [time, setTime] = useState("");
    const [errorTime, setErrorTime] = useState(false);
    const [errorText, setErrorText] = useState(false);
    const [duration, setDuration] = useState("");
    const [durationText, setDurationText] = useState("");

    const handleChange = (event) => {
      setTime(event.target.value);
      handleCurrentQuestion(data.id);
      setErrorTime(false);
    };

    const handleError = () => {
      if (durationText === "" || durationText === "other_specify") {
        setErrorText(true);
      }
      if (time === "") {
        setErrorTime(true);
      }
    };

    const nextQuestionHandler = (height, value) => {
     
      handlePayload(data, value);
      if ( data.key === "disruption_hours" && (value === "other_specify" || (duration !== "" && value !== "days" && value !== "hours" && value !== "minutes" && value !== duration))){
        handleCurrentQuestion(data.id);
      }else {
        scrollToQuestion(data, height, value);
      }
    };

    useEffect(() => {
      if (
        data.key === "software_type" &&
        value !== "microsoft_office" &&
        value !== "google_workspace" &&
        value !== null
      ) {
        setTextfieldOn(true);
        if (value !== "other") {
          setOther(value);
        }
      } else if (data.comboBox) {
        if (
          value === "other_specify" ||
          (value !== "" &&
            value !== "days" &&
            value !== "hours" &&
            value !== "minutes")
        ) {
          setComboBoxOn(true);
          handleCurrentQuestion(data.id);
        } else {
          setComboBoxOn(false);
        }
      }
    }, [data, value]);

    useEffect(() => {
      if (
        value !== "" &&
        value !== "days" &&
        value !== "hours" &&
        value !== "minutes" &&
        data.key === "disruption_hours"
      ) {
        setDuration(value);
      } else {
        setDuration("");
      }
    }, [value]);

    useEffect(() => {
      setDuration(`${durationText} ${time}`);
    }, [durationText, time]);

    useEffect(() => {
      if (
        value !== "" &&
        value !== "days" &&
        value !== "hours" &&
        value !== "minutes" &&
        data.key === "disruption_hours"
      ) {
        setDurationText(value?.split(" ")[0]);
        value?.split(" ")[1] && setTime(value?.split(" ")[1]);
      }
    }, [value]);
    return (
      <div style={{ padding: isMobile ? "100px 0px" : "100px 20px" }} ref={ref}>
        <>
          <Typography variant="subtitle1">{t(data.question)}</Typography>
          <Grid
            container
            spacing={2}
            style={{ display: "flex", flexDirection: "column" }}
          >
            {data?.choises.map((choise, index) => (
              <Grid item xs={15} key={`radio${index}`}>
                <RadioAnswer
                  title={
                    (data.key === "datacenter_number_C" || data.key === "disruption_hours")
                      ? t(choise.label)
                      : t(choise.value)
                  }
                  id={choise.id}
                  checked={
                    data.key === "software_type" && other !== ""
                      ? choise.value === "other"
                      : value !== "" &&
                        value !== "days" &&
                        value !== "hours" &&
                        value !== "minutes" &&
                        data.key === "disruption_hours"
                        ? choise.value === "other_specify"
                        : choise.value === value
                  }
                  value={choise.value}
                  handelRequiredQuestion={handelRequiredQuestion}
                  nextQuestionHandler={(value) => {
                    data.key === "software_type" &&
                      value !== "microsoft_office" &&
                      value !== "google_workspace" &&
                      value !== null
                      ? handleOfficeSoftware(value)
                      : nextQuestionHandler(ref.current.clientHeight, value);
                    setTextfieldOn(false);
                    setOther("");
                    setDuration("");
                    setTime("");
                    setDurationText("");
                  }}
                  lastStepQuestion={data.lastStepQuestion}
                />
              </Grid>
            ))}
          </Grid>
          {textfieldOn && (
            <>
              <br></br>
              <TextField
                id="outlined-basic"
                placeholder={t("other")}
                variant="outlined"
                fullWidth
                value={other}
                onChange={(e) => {
                  setOther(e.target.value);
                }}
                InputProps={{
                  sx: {
                    '& input[type=number]': {
                      MozAppearance: 'textfield',
                      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                        display: 'none',
                      },
                    },
                  },
                }}
              />
            </>
          )}
          {comboBoxOn && (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  id="outlined-basic"
                  placeholder={t("duration")}
                  type="number"
                  variant="outlined"
                  fullWidth
                  value={String(durationText).replace(/^0+/, "")}
                  error={errorText}
                  helperText={errorText && t("required_field")}
                  InputProps={{
                    inputProps: {
                      min: 1,
                    },
                    sx: {
                      '& input[type=number]': {
                        MozAppearance: 'textfield',
                        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                          display: 'none',
                        },
                      },
                    },
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                   if (value > 0){
                    setDurationText(value);
                    handleCurrentQuestion(data.id);
                    setErrorText(false);
                   } else{
                    setDurationText("");
                    setErrorText(true);
                   }
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth error={errorTime}>
                  <InputLabel id="demo-simple-select-label">
                    {t("unit")}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ height: "auto" }}
                    value={time}
                    label={t("unit")}
                    onChange={handleChange}
                    error={errorTime}
                  >
                    <MenuItem value={"minutes"}>{t("minutes")}</MenuItem>
                    <MenuItem value={"hours"}>{t("hours")}</MenuItem>
                    <MenuItem value={"days"}>{t("days")}</MenuItem>
                  </Select>
                  {errorTime && (
                    <FormHelperText>{t("required_field")}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          )}
          {(currentQuestion === data.id &&
            currentQuestion !== latestQuestion &&
            !(isEdit && latestStepQuestion === data.id)) || (data.key === "disruption_hours" && duration !== "" && value !== "days" && value !== "hours" && value !== "minutes" && value !== duration ) ? (
            <>
              {" "}
              {/* <br></br> */}
              <Button
                onClick={(option) => {
                  comboBoxOn &&
                    (time === "" ||
                      durationText === "" ||
                      durationText === "other_specify")
                    ? handleError()
                    : nextQuestionHandler(
                      ref.current.clientHeight,
                      textfieldOn
                        ? other
                        : data.comboBox 
                          ? duration
                          : value
                    );
                }}
                disabled={
                  isEdit
                    ? value === null || value === ""
                    : textfieldOn
                      ? other === ""
                      : data.required
                }
                style={{ height: "50px", marginTop: "20px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    );
  }
);

export default RadioQuestion;
